export default function LocationIcon() {
  return (
    <svg
      width="14"
      height="18"
      viewBox="0 0 14 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7 9.625C8.38071 9.625 9.5 8.50571 9.5 7.125C9.5 5.74429 8.38071 4.625 7 4.625C5.61929 4.625 4.5 5.74429 4.5 7.125C4.5 8.50571 5.61929 9.625 7 9.625Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.25 7.125C13.25 12.75 7 17.125 7 17.125C7 17.125 0.75 12.75 0.75 7.125C0.75 5.4674 1.40848 3.87769 2.58058 2.70558C3.75269 1.53348 5.3424 0.875 7 0.875C8.6576 0.875 10.2473 1.53348 11.4194 2.70558C12.5915 3.87769 13.25 5.4674 13.25 7.125Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
